import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'
const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    items: [],
    section_items: [],
    pagination: null,
    sectionPagination: null,
    historyItems:[],
    sectionLoadingState: false,
}


const getters = {
    sections(state) {
        const item = state.item || {}
        const sections = item.sections || []
        return sections
    },
}

const mutations = {
    SET_ITEM(state, payload) {
        state.item = payload
    },
    SET_HISTORYITEMS(state, payload) {
        state.historyItems = payload
    },
    SET_ITEMS(state, payload) {
        state.items = payload
    },

    SET_PAGINATION(state, pag) {
        state.pagination = pag
    },
    SET_SECTIONPAGINATION(state, sectionpage) {
        state.sectionPagination = sectionpage
    },

    SET_SECTION_ITEMS(state, payload) {
        state.section_items = payload
    },
    SET_ITEM_MASTER(state, payload) {
        state.section_master = payload
    },
  
}

const actions = {
    async fetchById(context, id) {
        try {
            const results = await api('get', `master-item/${id}`)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchByIdFunction(_, id) {
        try {
            const results = await api('get', `master-item/${id}`)
            return results.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchallMaster(context) {
        try {
            const results = await api('get', `master-item/inventory`)
            context.commit('SET_ITEM_MASTER', results)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetch(context, params) {
        console.log('masterItem/fetch', params)
        // Destructure Params
        let { query, page: pg, filters } = params || {}

        // Initialize query params and filters if nothing is passed in
        query = query || ''
        pg = pg || 1
        filters = filters || {}
        try {
            console.log("ORG filters:::",filters)
            const path = `master-item?q=${query}&page=${pg}&${buildQuery(
                filters
            )}`

            const results = await api('get', path)
            console.log('fetch results', results)

            // Destructure search data
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data

            context.commit('SET_ITEMS', data)
            // set pagination object
            context.commit('SET_PAGINATION', {
                page,
                pageSize,
                total,
            })
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchHistory(context, params) {
        console.log('masterItem/fetchHistory', params.ids.length)
        // Destructure Params
        // Initialize query params and filters if nothing is passed in
        try {
            if(params.product_search != '' && params.product_search != undefined){
                path = `master-item/inventory?from_date=${params.from_date}&to_date=${params.to_date}&product_search=${params.product_search}`
            }else{
                if(params.ids.length > 1){
                    var path = ''
                    path = `master-item/inventory?ids[]=${params.ids.join('&ids[]=')}&from_date=${params.from_date}&to_date=${params.to_date}`
                }else{
                    path = `master-item/inventory?ids[]=${params.ids}&from_date=${params.from_date}&to_date=${params.to_date}`
                }
            }

            const results = await api('get', path)
            // console.log('fetch historyresults', results)

            // Destructure search data
            let data= results.data.success.data.data

            context.commit('SET_HISTORYITEMS', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchSection(context, params) {
        // Destructure Params
        let { query, page: pg, filters } = params || {}

        // Initialize query params and filters if nothing is passed in
        query = query || ''
        pg = pg || 1
        filters = filters || {}
        try {
            console.log("filters:::",filters)
            const path = `master-item/inventory/?q=${query}&page=${pg}&${buildQuery(
                filters
            )}`

            const results = await api('get', path)
            console.log('fetch results', results)

            // Destructure search data
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data

            // set pagination object
            context.commit('SET_SECTIONPAGINATION', {
                page,
                pageSize,
                total,
            })
            context.commit('SET_SECTION_ITEMS', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchBySection(context, section_id) {
        console.log('fetchBySection-section_id', section_id)
        try {
            const results = await api(
                'get',
                `master-item/section/${section_id}`
            )
            

            // console.log("Adasdadadadad")
            const sectionItems = results.data.success.data
            console.log('fetchBySection data', results)
            context.commit('SET_SECTION_ITEMS', sectionItems)
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, payload) {
        try {
            const results = await api('post', `master-item`, payload)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async transfer(context, payload) {
        try {
            const results = await api('post', `master-item/bulk-inventory-transfer`, payload)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `master-item/${payload.id}`,
                payload
            )
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `master-item/${id}`)
            context.commit('SET_ITEM', null)
            context.dispatch('fetch')
        } catch (err) {
            errorHandler(err)
        }
    },

    //sections
    async addSection(context, { master_item_id, model }) {
        try {
            const path = `master-item/${master_item_id}/sections`
            const results = await api('post', path, model)
            context.commit('SET_ITEM', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

   
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
